export default __webpack_public_path__ + "static/media/landing_ENG_03.4d9ec36c.png";